import {Link, useNavigate} from 'react-router-dom'
import {LogOut, User, Video} from 'lucide-react'
import favicon from '@/app/assets/favicon.svg'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/shared/ui'
import {STORAGE_KEYS} from '@/shared/config'
import {useAuthStore} from '@/features/auth'
import {cn, useLocalStorage} from '@/shared/lib'

export function AppHeader() {
  const navigate = useNavigate()
  const logout = useAuthStore(s => s.logout)
  const isAuthenticated = useAuthStore(s => s.isAuthenticated)
  const userEmail = useAuthStore(s => s.userEmail)
  const [username] = useLocalStorage<string>(STORAGE_KEYS.USERNAME, '')

  const handleLogout = () => {
    logout()
    navigate('/')
  }

  return (
    <header
      className={cn('sticky top-0 z-40 flex w-full items-center justify-between px-4 py-3 sm:px-6')}
    >
      <Link
        to="/"
        className={cn(
          'group flex items-center gap-2 text-xl font-semibold tracking-tight font-logo transition-all duration-200',
          'text-foreground hover:text-primary',
        )}
      >
        <img
          src={favicon}
          alt=""
          className="size-8 shrink-0 transition-transform duration-200 group-hover:scale-110"
          width={32}
          height={32}
          aria-hidden
        />
        <span className="whitespace-nowrap transition-colors duration-200">SPeach</span>
      </Link>
      <div className="flex items-center gap-2">
        {isAuthenticated ? (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button
                type="button"
                className="flex items-center gap-2 rounded-full bg-primary/20 py-1.5 pl-2 pr-3 text-primary outline-none ring-ring cursor-pointer hover:bg-primary/30 transition-all duration-200"
                aria-label="Меню пользователя"
              >
                <span className="flex size-8 items-center justify-center rounded-full bg-primary/30">
                  <User className="size-4" />
                </span>
                <span className="max-w-[120px] truncate text-sm font-medium text-foreground">
                  {username?.trim() || 'Аккаунт'}
                </span>
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
              {userEmail ? (
                <>
                  <DropdownMenuLabel className="font-normal p-1.5">
                    <p className="text-muted-foreground text-xs">Email</p>
                    <p className="truncate text-sm">{userEmail}</p>
                  </DropdownMenuLabel>
                  <DropdownMenuSeparator />
                </>
              ) : null}
              <DropdownMenuItem asChild className="cursor-pointer transition-all duration-200">
                <Link to="/recordings">
                  <Video className="size-4" />
                  Записи
                </Link>
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                className="text-destructive focus:text-destructive cursor-pointer transition-all duration-200"
                onSelect={handleLogout}
              >
                <LogOut className="size-4" />
                Выйти
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        ) : null}
      </div>
    </header>
  )
}
